import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import SquadActivitySection from '../activity-section';
import GrowersByRVSection from '../growers-by-rv-section';

const ResumeSection = ({ userNodeId, year }: { userNodeId?: number; year: number }) => {
    return (
        <>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Resumen del Squad')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Actividad principal de la campaña actual')}
                </Typography>
            </Stack>
            {userNodeId ? (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 2fr' },
                        gap: 3,
                    }}
                >
                    <GrowersByRVSection userNodeId={userNodeId} />
                    <SquadActivitySection userNodeId={userNodeId} year={year} />
                </Box>
            ) : (
                <Skeleton variant='rectangular' height='500px' width='100%' />
            )}
        </>
    );
};

export default ResumeSection;
